import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "Preciso de internet rápida?",
    a: "Recomendamos pelo menos 15mbps para assistir em 4K sem travamentos. Para qualidade HD, 10mbps já é suficiente.",
  },
  {
    q: "Funciona na minha TV?",
    a: "Sim! Funciona em Smart TVs Samsung (Tizen, modelos 2016+), LG (webOS 3.0+), Android TV (Sony, Philips, TCL), Roku TV, TV Boxes, Fire TV Stick, celulares Android, iPhone, tablets e computadores.",
  },
  {
    q: "Como instalo o app na minha TV?",
    a: "É muito fácil: baixe o app 'Downloader' na loja oficial da sua TV, digite o código 857809 e o app New Braz será instalado automaticamente. Se preferir, nossa equipe envia o APK direto pelo WhatsApp e te ajuda na instalação.",
  },
  {
    q: "Tem fidelidade?",
    a: "Não, você pode cancelar quando quiser, sem multas ou taxas. Você só paga pelo período que escolher.",
  },
  {
    q: "Como funciona a ativação?",
    a: "Após a confirmação do pagamento, sua conta é ativada imediatamente. Enviamos o passo a passo de instalação pelo WhatsApp em poucos minutos.",
  },
  {
    q: "Quais aplicativos posso usar?",
    a: "Nosso serviço funciona com os apps New Braz (oficial P2P), New Hybrid, IBO Player, Smarters Pro, Dream TV, Purple IPTV, ISP IPTV, VEJO V3 e XCLOUD TV. Nossa equipe te ajuda a escolher e configurar o melhor para seu dispositivo.",
  },
  {
    q: "Posso assistir em mais de um dispositivo?",
    a: "O plano permite uso em 1 dispositivo por vez, mas você pode alternar facilmente entre Smart TV, celular, tablet e computador. Para multi-telas, fale com nosso atendimento no WhatsApp.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-24 px-4 sm:px-6 bg-[#0F0F13]/50 border-t border-white/10">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Dúvidas Frequentes</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
          Perguntas e respostas
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-[#0F0F13] border border-white/10 rounded-xl px-6 data-[state=open]:border-[#FF5A00]/40"
          >
            <AccordionTrigger className="text-left font-semibold hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/60 text-sm leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
